import { TITLE_STORE } from "src/constants";
import { TitleType } from "src/types";
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

const initialTitleState = {
  title: "",
};

export const useTitleStore = create(
  devtools(
    persist<TitleType>(
      (set) => ({
        ...initialTitleState,
        setTitle: (title: string) => {
          set(() => ({
            title,
          }));
        },
        clearTitleStore: () => {
          set(() => initialTitleState);
        },
      }),
      {
        name: TITLE_STORE,
      }
    )
  )
);
